import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxButtonComponent } from '@digipay/ngx-button';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { RouteStateService } from '@client-monorepo/common/utilities';
import {
  CAMPAIGN_OTP_ROUTE,
  HOME_ROUTE,
  TREASURE_HUNT_NATIONAL_ID_ROUTE,
  TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE,
} from '../../../../data-access/constants/app-routes';
import { CoordinatorPage } from '../../../../data-access/enums/coordinator-page';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { HomeService } from '../../../home/services/home.service';

@Component({
  selector: 'wealth-applet-campaign-start',
  standalone: true,
  imports: [CommonModule, NgxButtonComponent, NgxAppBarComponent],
  templateUrl: './campaign-start.component.html',
  styleUrl: './campaign-start.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignStartComponent implements OnInit {
  navigationService = inject(WealthNavigationService);
  routeState = inject(RouteStateService);
  state = { campaignCode: '', role: '' };
  homeService = inject(HomeService);

  ngOnInit(): void {
    this.state = this.routeState.getAll();
    if (!this.state.campaignCode) this.navigationService.navigate(HOME_ROUTE);
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }

  toNationalId() {
    this.homeService.getCampaignProcess(this.state.campaignCode).subscribe((res) => {
      if (res?.success) {
        if (res.result.data.pageName === CoordinatorPage.PAGE_CAMPAIGN_OTP) {
          this.navigationService.navigateWithState([CAMPAIGN_OTP_ROUTE], {
            state: {
              campaignCode: this.state.campaignCode,
              countDown: res.result.data.countdownInSeconds,
            },
          });
        } else if (res.result.data.pageName === CoordinatorPage.PAGE_CAMPAIGN_PRIZE_WAITING) {
          this.navigationService.navigateWithState([TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE], {
            state: {
              remainingDays: res.result.data.remainingDays,
            },
          });
        } else {
          this.navigationService.navigateWithState([TREASURE_HUNT_NATIONAL_ID_ROUTE], {
            state: {
              campaignCode: this.state.campaignCode,
              phoneNumber: res.result.data.phoneNumber,
              role: this.state.role,
            },
          });
        }
      }
    });
  }
}
